var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInboxSpam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.355 21h-6.71a.743.743 0 0 1-.572-.245l-4.828-4.828C3.082 15.845 3 15.6 3 15.355v-6.71c0-.245.082-.409.245-.572l4.828-4.828C8.155 3.082 8.4 3 8.645 3h6.791c.246 0 .41.082.573.245l4.827 4.828c.082.082.164.327.164.572v6.791c0 .246-.082.41-.245.573l-4.828 4.827c-.082.082-.327.164-.572.164zm-6.382-1.636h6.136l4.336-4.337V8.973l-4.418-4.337H8.973L4.636 8.973v6.136l4.337 4.255zM12.818 12V8.727c0-.49-.327-.818-.818-.818-.49 0-.818.327-.818.818V12c0 .49.327.818.818.818.49 0 .818-.327.818-.818zm-.245 3.845c.082-.081.163-.163.163-.245 0-.082.082-.245.082-.327 0-.082 0-.246-.082-.328-.081-.081-.081-.163-.163-.245 0 0-.082-.082-.164-.082s-.082-.082-.164-.082c-.327-.163-.654-.081-.9.164-.081.082-.163.164-.163.245 0 .082-.082.164-.082.328 0 .245.082.409.245.572a.743.743 0 0 0 .573.246c.327 0 .491-.082.655-.246z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-10h268v44H-24z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#BDBDBD",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInboxSpam);
export default __webpack_public_path__ + "static/media/ic-inbox-spam.84686dcc1da000b247d3df2d3fef1b93.svg";
export { ForwardRef as ReactComponent };